import React from 'react';

const teamMembers = [
  {
    name: 'Dr. Amina Otieno',
    role: 'Executive Director',
    image: '/images/amina.jpeg',
    bio: 'Amina leads IPSA with over 20 years in patient safety, healthcare policy, and regional advocacy.',
  },
  {
    name: 'Prof. David Mwangi',
    role: 'Director of Research',
    image: '/images/david.jpeg',
    bio: 'David oversees IPSA’s research initiatives, focusing on clinical safety and evidence-based practices.',
  },
  {
    name: 'Dr. Grace Njeri',
    role: 'Consultant – Clinical Governance',
    image: '/images/grace.jpeg',
    bio: 'Grace advises on hospital safety protocols and quality improvement across East African health systems.',
  },
  {
    name: 'Mr. Samuel Kibet',
    role: 'Consultant – Health Systems',
    image: '/images/samuel.jpeg',
    bio: 'Samuel brings expertise in digital health, systems design, and capacity building for rural clinics.',
  },
];

function TeamComponent() {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-10">Meet Our Team</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-blue-900 rounded-lg shadow-md p-6 text-center">
              <img
                src={member.image}
                alt={member.name}
                className="w-24 h-24 mx-auto rounded-full object-cover mb-4"
              />
              <h3 className="text-lg font-semibold text-gray-100">{member.name}</h3>
              <p className="text-sm text-blue-200 font-medium mb-2">{member.role}</p>
              <p className="text-sm text-gray-100">{member.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TeamComponent;
